import { Component, OnInit } from '@angular/core';
import { BrdsqlService } from '../../services/brdsql.service';
import { FirebaseService } from '../../services/firebase.service';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import Chart, { ChartDataSets } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import axios from 'axios';
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  brrdata?: any = [];
  chartData?: any = [];
  // ngxChart advance pipe
  single: any[] = [];;
  view: any[] = [800, 500];
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  colorScheme = {
    domain: ['#5AA454', '#C7B42C', '#A10A28', '#AAAAAA']
  };

  // KTD update coordinates ที่ dbintech.dbo.areas จาก firebase
  public itid? = ''
  cp2425?: any = [];
  fbData?: any = [];
  cpUpdated?: any = [];
  coordinates?: any;

  baseUrlSelect = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?"
  baseUrlUpdate = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?"
  baseUrlInsert = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?"
  baseUrlExe = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?"

  constructor(
    private brdservice: BrdsqlService,
    private fbService: FirebaseService,
  ) { }

  ngOnInit(): void {
    
  }

  getBrrSummary() {
    this.brdservice.getBrrsummary().subscribe({
      next: (res: any) => {
        this.brrdata = res.recordset
        this.drawMixChart();
      }, error(err) {
        alert('การเชื่อมต่อ api ผิดพลาด !!!!')
      }, complete() {
        // this.drawChart();
      }, closed
    })
  }

  cpgroupqdata?: any = []
  getCpgroupQ() {
    this.brdservice.getCpgroupQ('6667').subscribe({
      next: (res: any) => {
        this.cpgroupqdata = res.recordset
        // console.log('res: ', res)
        this.drawCpq();
      }, error(err) {
        alert('การเชื่อมต่อ api ผิดพลาด !!!!')
      }, complete() {
        // this.drawChart();
      }, closed
    })
  }

  drawMixChart() {
    let data = this.brrdata;
    data.map(elem => this.chartData.push({ name: elem.yearid, value: elem.caneareaPc }));
    // console.log('data :', this.chartData)
    let barlabel = data.map(function (elem) { return elem.yearid });
    let barAreadata = data.map((elm => elm.brrModelArea))
    let barTarget = data.map((elm => elm.canearea))
    let barPcArea = data.map((elm => elm.brrModelYield))
    // let ctx = document.getElementById('myChart')
    let chart = new Chart('mixChart', {
      type: "bar",
      data: {
        datasets: [{
          label: 'เป้าหมาย',
          data: barTarget,
          // this dataset is drawn below
          order: 0,
          backgroundColor: 'rgba(255, 0, 0, 0.2)',
          // borderColor: '#2CB2FF',
          // borderWidth: 1,
          barThickness: 'flex',
          borderSkipped: 'bottom',
          borderWidth: 5,
          datalabels: {
            align: 'end',
            anchor: 'start',
            color: '#444',
            formatter: function (value, context) {
              // return value.toLocaleString()
              return Number((value / 1000).toFixed(0)) + 'K';
            },
          },
        }, {
          label: 'ผลงาน',
          data: barAreadata,
          yAxisID: "id1",
          order: 1,
          backgroundColor: 'rgba(0,204,0,0.2)',
          borderWidth: 5,
          datalabels: {
            align: 'end',
            anchor: 'center',
            color: '#444',
            formatter: function (value, context) {
              // return value.toLocaleString()
              return Number((value / 1000).toFixed(0)) + 'K';
            },
          },
        }
          , {
          label: 'ผลผลิต',
          data: barPcArea,
          type: 'line',
          fill: false,
          yAxisID: "id2",
          // this dataset is drawn on top
          order: 2,
          borderColor: '#FF9C07',
          // tension: 0.05, // เส้นแบบตรง แบบไม่โค้งมน
          pointStyle: 'circle',
          pointRadius: 10,
          pointHoverRadius: 15,
          datalabels: {
            align: 'end',
            anchor: 'center',
            backgroundColor: '#FF8000',
            borderRadius: 20,
            color: '#000000',
            formatter: function (value, context) {
              return value.toFixed(0)
              // return Number((value / 1000).toFixed(0)) + 'K';
            },
          },
        }],
        labels: barlabel,
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1, // work for mobile 
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value.toLocaleString()
              // return Number((value / 1000).toString()) + 'K';
              // return value / 1000 + "k";
            },
            // color: '#fff',
            // backgroundColor: '#404040',
            align: 'center',
            anchor: 'center',  // ตำแหน่งข้อมูล
          },
        },
        // คำอธิบายข้อมูล
        legend: {
          display: true,
          position: 'top',
          // จัดรูปแบบของคำอธิบาย
          labels: {
            boxWidth: 10, // ความกว้างของกล่องสีบอกข้อมูล
            padding: 2,
          },
        },
        title: {
          text: "แปลง BRRModel",
          display: true,
          fontSize: 20
        },
        // จัดรูปแบบแกน แนวตั้ง แนวนอน
        scales: {
          xAxes: [{
            stacked: false,  //แท่งแบบต่อกัน 
            ticks: {
              display: true,
              fontSize: 14,
              showLabelBackdrop: true,
              callback: function (value: string, index, ticks) {
                return 'ปี' + value.substr(0, 2) + '/' + value.substr(2, 2)
              }
            },
          }],
          // format แกนตั้ง
          yAxes: [{
            display: true,
            position: 'left',
            // แกนตั้ง ด้านซ้าย
            ticks: {
              // fontSize: 14,
              beginAtZero: true,  // แกนตั้ง 
              // min: Math.min(0),
              // max: Math.max(100),
              // stepSize: 100000,
              // ทำให้แทนที่หลักพันด้วย K
              callback: function (value) {
                var ranges = [
                  { divider: 1e3, suffix: 'K' }
                ];
                function formatNumber(n) {
                  for (var i = 0; i < ranges.length; i++) {
                    if (n >= ranges[i].divider) {
                      return (n / ranges[i].divider).toString() + ranges[i].suffix;
                    }
                  }
                  return n;
                }
                return /*'$' +*/ formatNumber(value);
              }
            },
            id: "id1"
          }, {
            // แกนต้ัง ด้านขวา
            ticks: {
              // fontSize: 14,
              beginAtZero: true,
              min: Math.min(10),
              max: Math.max(20),
            },
            display: true, // Hopefully don't have to explain this one.
            position: "right",
            gridLines: {
              display: false,
            },
            id: "id2" // incorrect property name.
          }
          ],
        }
      }
    });

  }

  async drawCpq() {
    this.single = [];
    await this.cpgroupqdata.map(
      elem => this.single.push(
        { name: elem.qdesc, value: parseInt(elem.assess) }
      ));
    // console.log('cpgroup :' ,this.single)
  }

  data_group: {};
  groupedData: { [key: string]: any[] } = {};
  groupedDataKeys: string[] = [];
  load_data_A() {
    const data = [
      {
        "year": "63",
        "loancode": "63-L-04",
        "loandesc": "อุปกรณ์,เครื่องมือ BRD 63/64",
        "docdate": "2020-02-13T00:00:00.000Z",
        "doctotal": 350
      },
      {
        "year": "63",
        "loancode": "63-L-03",
        "loandesc": "ปุ๋ย,ยา  63/64",
        "docdate": "2020-06-15T00:00:00.000Z",
        "doctotal": 900
      },
      {
        "year": "65",
        "loancode": "66-L-03",
        "loandesc": "ปุ๋ย,ยา 66/67",
        "docdate": "2022-11-22T00:00:00.000Z",
        "doctotal": 97840
      },
      {
        "year": "66",
        "loancode": "66-L-03",
        "loandesc": "ปุ๋ย,ยา 66/67",
        "docdate": "2022-11-22T00:00:00.000Z",
        "doctotal": 7740
      },
      {
        "year": "66",
        "loancode": "66-L-03",
        "loandesc": "ปุ๋ย,ยา 66/67",
        "docdate": "2022-11-28T00:00:00.000Z",
        "doctotal": 3526
      }
    ];

    const groupedData = {};

    data.forEach(entry => {
      const year = entry.year;
      if (!groupedData[year]) {
        groupedData[year] = [];
      }
      groupedData[year].push(entry);
    });

    console.log('groupedData: ', groupedData);
    this.data_group = groupedData;

    this.groupedData = groupedData;
    this.groupedDataKeys = Object.keys(groupedData);

  }

  calculateTotal(entries: any[]): number {
    //console.log('entries: ', entries);    
    return entries.reduce((total, entry) => total + entry.doctotal, 0);
  }

  testData = [];
  loadAllcpFm(year: string, fmcode: string) {
    this.brdservice.listCpFm(year, fmcode).subscribe({
      next: (res: any) => {
        this.testData = res.recordsets[0]
        console.log('test res: ', this.testData)
        console.log('coordinates[0] :', this.testData[0].coordinates)
      }, error(err) {
        console.log('การเชื่อมต่อ api ผิดพลาด !!!!')
      }, complete: () => {
        console.log('load api listCpFm complete')
      }, closed
    })
  }

  loadData1() {
    let url = this.baseUrlSelect
      + "&s=top 1 itid,year,intlandno,status,coordinates"
      + "&f=[CPS6263].[dbo].[v_areas_2425]"
      + "&w=coordinates is null and status<>3 and CaneTypeName<>'ot' and [itid] not in (SELECT[itid]FROM [dbQBRD].[dbo].[v_areas_2425])"
    axios.get(url)
      .then(res => {
        // console.log('loadData1 res: ',res);
        if (res) {
          this.cp2425 = res.data.recordset;
          this.itid = this.cp2425[0].itid;
          console.log('loadData1 : ', this.cp2425);
        }
      }).catch(err => { throw (err) })
      .finally(() => {
        this.loadFbData(this.itid);
        console.log('finally loadData1');
      })
  }

  loadData2(itid: string) {
    let url = this.baseUrlSelect
      + "&s=top 1 itid,year,intlandno,status,coordinates"
      + "&f=[CPS6263].[dbo].[v_areas_2425]"
      + "&w=itid='" + itid + "'"
    axios.get(url)
      .then(res => {
        // console.log('loadData1 res: ',res);
        if (res) {
          this.cpUpdated = res.data.recordset;
          console.log('cpUpdated : ', this.cpUpdated);
        }
      }).catch(err => { throw (err) })
  }

  loadFbData(key: string) {
    // this.itid = key;
    console.log('key: ', key);
    this.fbService.getMapByitid('2425', key)
      .then((res: any) => {
        console.log('firebase res: ', res)
        let data = res;
        this.fbData = data;
        console.log('coordinatesCenter: ', data.coordinatesCenter);
        this.coordinates = JSON.stringify(data.coordinatesCenter);
      })
      .finally(() => {
        // console.log('finally')
      })
      .catch(e => {
        console.log('error ', e)
      })
  }

  updateSQL(itid: string, coordinates: any) {
    console.log('key ,cooridinates : ',itid ,coordinates);

    // let url = this.baseUrlUpdate
    //   + "&t=dbintech.dbo.areas"
    //   + "&s=coordinates='" + coordinates + "'"
    //   + "&w=itid='" + itid + "'"
    // axios.get(url)
    //   .then(res => {
    //     // console.log('loadData1 res: ',res);
    //     if (res) {
    //       this.cpUpdated = res.data.recordset;
    //       console.log('cpUpdated : ', this.cpUpdated);
    //     }
    //   })
    //   .catch(err => { throw (err) })
    //   .finally(() => {
    //     this.loadData2(itid);
    //   })
  }

}
